module.exports = "<div class=\"with_background bottommargin_25\">\r\n  <div class=\"widget widget_categories\">\r\n\r\n    <div class=\"widget-title\">\r\n      <h3>Categories</h3>\r\n    </div>\r\n    <ul class=\"greylinks\">\r\n      <li *ngFor=\"let item of masterList\">\r\n        <a href=\"blog-right.html\" title=\"\">{{item.newsAndEventCategoryNameEN}}</a>\r\n        <span>71</span>\r\n      </li>\r\n      \r\n    </ul>\r\n  </div>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/blog/news-category/news-category.component.html
// module id = ./src/app/components/blog/news-category/news-category.component.html
// module chunks = main